<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>公共積替詳細</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              事業場コード
            </div>
            <h4>{{ public_place.code }}&nbsp;</h4>
            <v-divider />
          </v-col>

          <v-col cols="12" md="6">
            <div class="overline">
              事業場名
            </div>
            <h4>{{ public_place.name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
            <div class="overline">
              所在地
            </div>
            <h4>〒{{ public_place.zip_code }}&emsp;{{ public_place.address }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ public_place.phone_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="error"
          :disabled="isJwMode"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          :disabled="isJwMode"
          color="primary"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  name: 'DriverMasterPublicPlaceShow',
  components: {
    Confirm
  },
  mixins: [],
  props: {},
  data () {
    return {
      breadcrumbs: [
        { text: '公共積替一覧', disabled: false, to: '/driver/masters/public_places', exact: true },
        { text: '公共積替詳細', disabled: true, to: '' },
      ],
      public_place: {},
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      isJwMode: 'use_jw_mode',
    }),
  },
  watch: {},
  created() {
    this.fetchPublicPlace({ id: this.$route.params.id }).then((content) => {
      this.public_place = content
    })
  },
  methods: {
    ...mapActions('DriverMasterPublicPlace', {
      fetchPublicPlace: 'show',
      deletePublicPlaces: 'destroy',
    }),
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
     editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterPublicPlaceEdit', params: { id: String(this.public_place.id) }})
    },
    /**
     * 閉じるボタン クリックイベント
     * @param item { Object }
     */
     cancelButtonClickEvent: function() {
      this.$router.push({ name: 'DriverMasterPublicPlaces' })
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
     deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deletePublicPlaces({id: this.public_place.id }).then(() =>{
            this.$router.push({name: 'DriverMasterPublicPlaces'})
          })
        }
      })
    },
  }
}
</script>
